import Vue from "vue";
import { Watch, Component, Prop } from "vue-property-decorator";
import { IConvergeModel, ConvergenceServices } from "../../scripts/ah.mb.convergence-services";
import { bootbox } from "../../infrastructure/bootbox-shim";
import { ClientNotifier, IBasicCommandResponse } from "../../scripts/ah.mb.client-notifications";
import { modelServices } from "../../scripts/ah.mb.ui.model-services";
import { IMultiSelectItem } from "../../infrastructure/multi-select-item";
import { IModelEventUserNotification } from "../event-notifications-editor-dialog/event-notifications-editor-dialog"

@Component
export default class ConvergeModelDialog extends Vue {

    @Prop()
    modelId: string;

    tempUserNotifications: Array<IModelEventUserNotification> = new Array<IModelEventUserNotification>();

    value: IConvergeModel = {
        modelId: "",
        iterations: 1000,
        maxPrice: 10,
        numCores: -1,
        resetType: "None",
        resourceCurveNumPoints: 10,
        resourceCurvePriceIncrement: 1,
        modelNamesToRun: [],
        scenarioNamesToRun: [],
        logConvergenceStats: false,
        logConvergenceRunStats: false,
        dryRun: false,
        userNotifications: new Array<IModelEventUserNotification>(),
        skipValidation: false,
        comments: ""
    }

    //eventNotificationsModel: IModelEventUserNotifications =

    //    { userNotifications: [] };

    modelNamesSelection: Array<IMultiSelectItem> = [];
    scenarioNamesSelection: Array<IMultiSelectItem> = [];

    // Create convergence services
    convergenceServices = new ConvergenceServices();

    userNotifier = new ClientNotifier();

    @Prop()
    modelServices: modelServices;

    isValidating: boolean = false;

    showEventNotificationsDialog: boolean = false;

    mounted() {

        if (!this.convergenceServices.convergenceAvailable()) {
            bootbox.alert("No converger is configured - please contact ArrowHead for assistance",
                () => this.$emit("dialogClosed", "cancel"));
        }

        // Try and get last user notifications, for convenience
        var previousUserNotifications = localStorage.getItem("converge_lastUserNotification");
        if (previousUserNotifications) {
            this.value.userNotifications = JSON.parse(previousUserNotifications);
        }
        else {
            // Use default notifications (start and stop convergence)
            this.value.userNotifications.push(
                { customMessage: "", emailRecipients: [], enabled: false, eventName: "Convergence Started", id: "", },
                { customMessage: "", emailRecipients: [], enabled: false, eventName: "Convergence Complete", id: "", },
            )
        }

        this.refreshModelNamesSelection(this.modelId);
        this.refreshScenarioNamesSelection(this.modelId);
    }

    refreshModelNamesSelection(modelId: string) {
        if (modelId)
            this.modelServices.getModelNames(modelId)
                .then(value => {
                    this.modelNamesSelection = value.map(item => ({
                        label: item.name, value: item.name
                    }));

                    switch (this.modelNamesSelection.length) {
                        case 0:
                        case 1:
                            this.value.modelNamesToRun = [];
                            break;
                        default:
                            this.value.modelNamesToRun = this.modelNamesSelection.map(p => p.value);
                            break;
                    }
                });

    }

    refreshScenarioNamesSelection(modelId: string) {
        if (modelId)
            this.modelServices.getScenarioNames(modelId)
                .then(value => {
                    this.scenarioNamesSelection = value.map(item => ({
                        label: item.name, value: item.name
                    }));
                    this.value.scenarioNamesToRun = this.scenarioNamesSelection.map(p => p.value);
                });

    }

    @Watch("modelId")
    modelIdChanged(newVal, oldVal) {
        this.refreshModelNamesSelection(newVal);
        this.refreshScenarioNamesSelection(newVal);
    }


    convergeFunc() {

        this.value.modelId = this.modelId;

        this.convergenceServices.convergeModel(this.value)
            .then(response => {
                if (response.success) {
                    bootbox.confirm(response.response +
                        ", view convergence monitor?",
                        (ok: boolean) => {

                            if (ok)
                                this.$router.push({ name: "convergence-monitor" });

                        });
                } else
                    bootbox.alert(response.response, () => { });

            });


        this.$emit("dialogClosed", "ok");
    }


    executeValidateModel(): Promise<IBasicCommandResponse> {
        if (this.value.skipValidation)

            return Promise.resolve({ success: true, response: "" });

        return this.modelServices.validateModel(this.modelId);

    }

    async onConvergeClick():Promise<any> {


        var doContinue = true;

        if (this.value.skipValidation) {
            doContinue = await bootbox.confirm2(`Skipping validation for model ${this.modelId} may result in unexpected errors during convergence.  Are you sure?`);
        }

        if (doContinue) { // If user has not opted to skip validation

            // userNotifier.showNotification("Validating model...", true, true);
            var notification = this.userNotifier.showBusyNotification("Validating model...");

            this.isValidating = true;

            this.executeValidateModel()
                .then(response => {
                    this.isValidating = false;
                    this.userNotifier.clear(notification);
                    if (!response.success) {
                        this.promptToNavigateToModelValidationPage(this.modelId);
                        this.$emit("dialogClosed", "cancel");

                    } else {

                        if (response.response) // Indicates ok, with warnings
                        {
                            bootbox.confirm(
                                `${response.response}\nContinue convergence (Ok) or view warnings (Cancel)?`,
                                (ok) => {
                                    if (ok)
                                        this.convergeFunc();
                                    else {
                                        this.$emit("dialogClosed", "cancel");
                                        this.$router.push({
                                            name: "model-validation",
                                            params: { modelId: this.modelId }
                                        });
                                    }

                                    //                                        window.location.href = `/ModelValidation/${this.}`;

                                });
                        } else {
                            this.convergeFunc();

                        }

                    }
                });
        }
    }


    promptToNavigateToModelValidationPage(modelId: string) {
        bootbox.confirm(`Model ${modelId} has validation failures.  View now?`,
            viewNow => {
                if (viewNow)
                    this.$router.push({ name: "model-validation", params: { modelId: modelId } });
            });
        this.$emit("dialogClosed", "cancel");

    };

    onCancelClick() {
        this.$emit("dialogClosed", "cancel");
    }

    onNotificationsClick() {
        this.tempUserNotifications = [...this.value.userNotifications];
        this.showEventNotificationsDialog = true;
    }

    eventNotificationsDialogAccepted(response: string) {
        if (response == "ok") {
            this.value.userNotifications = [...this.tempUserNotifications];

            // Save to local storage for convenience, for next run
            var notificationsJson = JSON.stringify(this.value.userNotifications);
            localStorage.setItem("converge_lastUserNotification", notificationsJson);
        }
    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/converge-model-dialog/converge-model-dialog.ts